module.exports = __webpack_public_path__ + "static/media/pholidoptera_fallax.0fd09e5f.jpg";